import { useEffect, useRef, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay: number) {
  const [debounced, setDebounced] = useState(value);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    timeoutRef.current = setTimeout(() => setDebounced(value), delay);

    return () => clearTimeout(timeoutRef.current);
  }, [value, delay]);

  return debounced;
}
